/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HelpRouteImport } from './routes/help'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsTeamRouteImport } from './routes/settings/team'
import { Route as SettingsSetupChecklistRouteImport } from './routes/settings/setup-checklist'
import { Route as SettingsAccountRouteImport } from './routes/settings/account'
import { Route as ScoutSuppressionsRouteImport } from './routes/scout/suppressions'
import { Route as ScoutExportRouteImport } from './routes/scout/export'
import { Route as ScoutComposeRouteImport } from './routes/scout/compose'
import { Route as AdminWorkspacesRouteImport } from './routes/admin/workspaces'
import { Route as ScoutRunsIndexRouteImport } from './routes/scout/runs/index'
import { Route as OrgStatusIndexRouteImport } from './routes/org/status/index'
import { Route as ScoutRunsRunIdRouteImport } from './routes/scout/runs/$runId'
import { Route as ScoutQaRunIdRouteImport } from './routes/scout/qa/$runId'
import { Route as ScoutQaRunIdIndexRouteImport } from './routes/scout/qa/$runId/index'
import { Route as ScoutQaRunIdSummaryRouteImport } from './routes/scout/qa/$runId/summary'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/settings.lazy').then((d) => d.Route))
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/accept-invite.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any).lazy(() =>
  import('./routes/settings/index.lazy').then((d) => d.Route),
)
const SettingsTeamRoute = SettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => SettingsRoute,
} as any).lazy(() => import('./routes/settings/team.lazy').then((d) => d.Route))
const SettingsSetupChecklistRoute = SettingsSetupChecklistRouteImport.update({
  id: '/setup-checklist',
  path: '/setup-checklist',
  getParentRoute: () => SettingsRoute,
} as any).lazy(() =>
  import('./routes/settings/setup-checklist.lazy').then((d) => d.Route),
)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRoute,
} as any).lazy(() =>
  import('./routes/settings/account.lazy').then((d) => d.Route),
)
const ScoutSuppressionsRoute = ScoutSuppressionsRouteImport.update({
  id: '/scout/suppressions',
  path: '/scout/suppressions',
  getParentRoute: () => rootRouteImport,
} as any)
const ScoutExportRoute = ScoutExportRouteImport.update({
  id: '/scout/export',
  path: '/scout/export',
  getParentRoute: () => rootRouteImport,
} as any)
const ScoutComposeRoute = ScoutComposeRouteImport.update({
  id: '/scout/compose',
  path: '/scout/compose',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWorkspacesRoute = AdminWorkspacesRouteImport.update({
  id: '/admin/workspaces',
  path: '/admin/workspaces',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/workspaces.lazy').then((d) => d.Route),
)
const ScoutRunsIndexRoute = ScoutRunsIndexRouteImport.update({
  id: '/scout/runs/',
  path: '/scout/runs/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgStatusIndexRoute = OrgStatusIndexRouteImport.update({
  id: '/org/status/',
  path: '/org/status/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScoutRunsRunIdRoute = ScoutRunsRunIdRouteImport.update({
  id: '/scout/runs/$runId',
  path: '/scout/runs/$runId',
  getParentRoute: () => rootRouteImport,
} as any)
const ScoutQaRunIdRoute = ScoutQaRunIdRouteImport.update({
  id: '/scout/qa/$runId',
  path: '/scout/qa/$runId',
  getParentRoute: () => rootRouteImport,
} as any)
const ScoutQaRunIdIndexRoute = ScoutQaRunIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ScoutQaRunIdRoute,
} as any)
const ScoutQaRunIdSummaryRoute = ScoutQaRunIdSummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => ScoutQaRunIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRouteWithChildren
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/scout/compose': typeof ScoutComposeRoute
  '/scout/export': typeof ScoutExportRoute
  '/scout/suppressions': typeof ScoutSuppressionsRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/setup-checklist': typeof SettingsSetupChecklistRoute
  '/settings/team': typeof SettingsTeamRoute
  '/settings/': typeof SettingsIndexRoute
  '/scout/qa/$runId': typeof ScoutQaRunIdRouteWithChildren
  '/scout/runs/$runId': typeof ScoutRunsRunIdRoute
  '/org/status': typeof OrgStatusIndexRoute
  '/scout/runs': typeof ScoutRunsIndexRoute
  '/scout/qa/$runId/summary': typeof ScoutQaRunIdSummaryRoute
  '/scout/qa/$runId/': typeof ScoutQaRunIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/scout/compose': typeof ScoutComposeRoute
  '/scout/export': typeof ScoutExportRoute
  '/scout/suppressions': typeof ScoutSuppressionsRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/setup-checklist': typeof SettingsSetupChecklistRoute
  '/settings/team': typeof SettingsTeamRoute
  '/settings': typeof SettingsIndexRoute
  '/scout/runs/$runId': typeof ScoutRunsRunIdRoute
  '/org/status': typeof OrgStatusIndexRoute
  '/scout/runs': typeof ScoutRunsIndexRoute
  '/scout/qa/$runId/summary': typeof ScoutQaRunIdSummaryRoute
  '/scout/qa/$runId': typeof ScoutQaRunIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRouteWithChildren
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/scout/compose': typeof ScoutComposeRoute
  '/scout/export': typeof ScoutExportRoute
  '/scout/suppressions': typeof ScoutSuppressionsRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/setup-checklist': typeof SettingsSetupChecklistRoute
  '/settings/team': typeof SettingsTeamRoute
  '/settings/': typeof SettingsIndexRoute
  '/scout/qa/$runId': typeof ScoutQaRunIdRouteWithChildren
  '/scout/runs/$runId': typeof ScoutRunsRunIdRoute
  '/org/status/': typeof OrgStatusIndexRoute
  '/scout/runs/': typeof ScoutRunsIndexRoute
  '/scout/qa/$runId/summary': typeof ScoutQaRunIdSummaryRoute
  '/scout/qa/$runId/': typeof ScoutQaRunIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/help'
    | '/login'
    | '/settings'
    | '/admin/workspaces'
    | '/scout/compose'
    | '/scout/export'
    | '/scout/suppressions'
    | '/settings/account'
    | '/settings/setup-checklist'
    | '/settings/team'
    | '/settings/'
    | '/scout/qa/$runId'
    | '/scout/runs/$runId'
    | '/org/status'
    | '/scout/runs'
    | '/scout/qa/$runId/summary'
    | '/scout/qa/$runId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/help'
    | '/login'
    | '/admin/workspaces'
    | '/scout/compose'
    | '/scout/export'
    | '/scout/suppressions'
    | '/settings/account'
    | '/settings/setup-checklist'
    | '/settings/team'
    | '/settings'
    | '/scout/runs/$runId'
    | '/org/status'
    | '/scout/runs'
    | '/scout/qa/$runId/summary'
    | '/scout/qa/$runId'
  id:
    | '__root__'
    | '/'
    | '/accept-invite'
    | '/help'
    | '/login'
    | '/settings'
    | '/admin/workspaces'
    | '/scout/compose'
    | '/scout/export'
    | '/scout/suppressions'
    | '/settings/account'
    | '/settings/setup-checklist'
    | '/settings/team'
    | '/settings/'
    | '/scout/qa/$runId'
    | '/scout/runs/$runId'
    | '/org/status/'
    | '/scout/runs/'
    | '/scout/qa/$runId/summary'
    | '/scout/qa/$runId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcceptInviteRoute: typeof AcceptInviteRoute
  HelpRoute: typeof HelpRoute
  LoginRoute: typeof LoginRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  AdminWorkspacesRoute: typeof AdminWorkspacesRoute
  ScoutComposeRoute: typeof ScoutComposeRoute
  ScoutExportRoute: typeof ScoutExportRoute
  ScoutSuppressionsRoute: typeof ScoutSuppressionsRoute
  ScoutQaRunIdRoute: typeof ScoutQaRunIdRouteWithChildren
  ScoutRunsRunIdRoute: typeof ScoutRunsRunIdRoute
  OrgStatusIndexRoute: typeof OrgStatusIndexRoute
  ScoutRunsIndexRoute: typeof ScoutRunsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/team': {
      id: '/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof SettingsTeamRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/setup-checklist': {
      id: '/settings/setup-checklist'
      path: '/setup-checklist'
      fullPath: '/settings/setup-checklist'
      preLoaderRoute: typeof SettingsSetupChecklistRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/scout/suppressions': {
      id: '/scout/suppressions'
      path: '/scout/suppressions'
      fullPath: '/scout/suppressions'
      preLoaderRoute: typeof ScoutSuppressionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scout/export': {
      id: '/scout/export'
      path: '/scout/export'
      fullPath: '/scout/export'
      preLoaderRoute: typeof ScoutExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scout/compose': {
      id: '/scout/compose'
      path: '/scout/compose'
      fullPath: '/scout/compose'
      preLoaderRoute: typeof ScoutComposeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/workspaces': {
      id: '/admin/workspaces'
      path: '/admin/workspaces'
      fullPath: '/admin/workspaces'
      preLoaderRoute: typeof AdminWorkspacesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scout/runs/': {
      id: '/scout/runs/'
      path: '/scout/runs'
      fullPath: '/scout/runs'
      preLoaderRoute: typeof ScoutRunsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/status/': {
      id: '/org/status/'
      path: '/org/status'
      fullPath: '/org/status'
      preLoaderRoute: typeof OrgStatusIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scout/runs/$runId': {
      id: '/scout/runs/$runId'
      path: '/scout/runs/$runId'
      fullPath: '/scout/runs/$runId'
      preLoaderRoute: typeof ScoutRunsRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scout/qa/$runId': {
      id: '/scout/qa/$runId'
      path: '/scout/qa/$runId'
      fullPath: '/scout/qa/$runId'
      preLoaderRoute: typeof ScoutQaRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scout/qa/$runId/': {
      id: '/scout/qa/$runId/'
      path: '/'
      fullPath: '/scout/qa/$runId/'
      preLoaderRoute: typeof ScoutQaRunIdIndexRouteImport
      parentRoute: typeof ScoutQaRunIdRoute
    }
    '/scout/qa/$runId/summary': {
      id: '/scout/qa/$runId/summary'
      path: '/summary'
      fullPath: '/scout/qa/$runId/summary'
      preLoaderRoute: typeof ScoutQaRunIdSummaryRouteImport
      parentRoute: typeof ScoutQaRunIdRoute
    }
  }
}

interface SettingsRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsSetupChecklistRoute: typeof SettingsSetupChecklistRoute
  SettingsTeamRoute: typeof SettingsTeamRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsSetupChecklistRoute: SettingsSetupChecklistRoute,
  SettingsTeamRoute: SettingsTeamRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface ScoutQaRunIdRouteChildren {
  ScoutQaRunIdSummaryRoute: typeof ScoutQaRunIdSummaryRoute
  ScoutQaRunIdIndexRoute: typeof ScoutQaRunIdIndexRoute
}

const ScoutQaRunIdRouteChildren: ScoutQaRunIdRouteChildren = {
  ScoutQaRunIdSummaryRoute: ScoutQaRunIdSummaryRoute,
  ScoutQaRunIdIndexRoute: ScoutQaRunIdIndexRoute,
}

const ScoutQaRunIdRouteWithChildren = ScoutQaRunIdRoute._addFileChildren(
  ScoutQaRunIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptInviteRoute: AcceptInviteRoute,
  HelpRoute: HelpRoute,
  LoginRoute: LoginRoute,
  SettingsRoute: SettingsRouteWithChildren,
  AdminWorkspacesRoute: AdminWorkspacesRoute,
  ScoutComposeRoute: ScoutComposeRoute,
  ScoutExportRoute: ScoutExportRoute,
  ScoutSuppressionsRoute: ScoutSuppressionsRoute,
  ScoutQaRunIdRoute: ScoutQaRunIdRouteWithChildren,
  ScoutRunsRunIdRoute: ScoutRunsRunIdRoute,
  OrgStatusIndexRoute: OrgStatusIndexRoute,
  ScoutRunsIndexRoute: ScoutRunsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
